import { MantineThemeProvider, createTheme } from '@mantine/core';

/**
 * Mantine's defaults, for V2 pages only.
 *
 * `MantineThemeProvider` overrides the theme for one part of the tree without re-emitting the CSS
 * variables a second `MantineProvider` would — which is what makes this safe: the shared
 * `theme/index.js` is untouched, so a legacy page keeps the controls it has always had.
 *
 * Only default props are set here, deliberately. Sizes and spacing already have one home in
 * tokens.css; re-declaring `fontSizes` on a nested theme provider would not emit variables anyway,
 * so it would be a second source of truth that does nothing. What this removes is the `size="xs"`
 * every V2 page repeats on every control it mounts.
 */
const v2Theme = createTheme({
  defaultRadius: 'sm',
  components: {
    Button: { defaultProps: { size: 'xs' } },
    TextInput: { defaultProps: { size: 'xs' } },
    Select: { defaultProps: { size: 'xs' } },
    MultiSelect: { defaultProps: { size: 'xs' } },
    NumberInput: { defaultProps: { size: 'xs' } },
    Textarea: { defaultProps: { size: 'xs' } },
    ActionIcon: { defaultProps: { size: 'sm', variant: 'subtle', color: 'gray' } },
    Pagination: { defaultProps: { size: 'xs', withControls: false, withEdges: false } },
    Checkbox: { defaultProps: { size: 'xs' } },
    Tooltip: { defaultProps: { withArrow: true, openDelay: 200 } }
  }
});

export const V2Theme = ({ children }) => (
  <MantineThemeProvider theme={v2Theme}>{children}</MantineThemeProvider>
);
